module.exports = __webpack_public_path__ + "img/lg_ring_r_o_0_1@2x.627c89fa.png";